import { useMemo } from "react";
import { useSvgViewBoxZoom } from "../../hooks/useSvgViewBoxZoom";
import { useSuperformula } from "./SuperformulaContext";

export function SuperformulaViewer() {
    const {
        viewBoxAttr,
        size,
        pathD,
        fillColor,
        strokeColor,
        bgColor,
        strokeWidth,
        fillShapes,
        canExport,
        handleDownload,
    } = useSuperformula();

    const base = useMemo(() => {
        const [x, y, w, h] = viewBoxAttr.split(" ").map(Number);
        return { x, y, w, h };
    }, [viewBoxAttr]);

    const {
        svgRef,
        viewBoxAttr: viewBox,
        panHandlers,
        zoomPercent,
        zoomIn,
        zoomOut,
        resetView,
    } = useSvgViewBoxZoom({ base });

    return (
        <div className="panel-viewer superformula-viewer">
            <div className="path-tool-preview">
                {/* Zoom controls */}
                <div className="svg-zoom-controls">
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomOut}
                        title="Zoom out"
                    >
                        −
                    </button>
                    <span className="zoom-level">{zoomPercent}%</span>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomIn}
                        title="Zoom in"
                    >
                        +
                    </button>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={resetView}
                        title="Reset zoom"
                    >
                        ⌂
                    </button>
                </div>

                {/* Scrollable SVG */}
                <div className="svg-scroll-wrapper">
                    <div className="svg-container svg-container--fill">
                        <svg
                            ref={svgRef}
                            viewBox={viewBox}
                            xmlns="http://www.w3.org/2000/svg"
                            className="path-tool-svg"
                            style={{ touchAction: "none" }}
                            {...panHandlers}
                        >
                            <rect
                                x={-size / 2}
                                y={-size / 2}
                                width={size}
                                height={size}
                                fill={bgColor}
                            />
                            {pathD && (
                                <path
                                    d={pathD}
                                    fill={fillShapes ? fillColor : "none"}
                                    stroke={strokeColor}
                                    strokeWidth={strokeWidth}
                                />
                            )}
                        </svg>
                    </div>
                </div>

                {/* Footer */}
                <div className="path-tool-footer">
                    <p className="path-tool-meta">
                        {pathD
                            ? `viewBox: ${size} × ${size}`
                            : "Degenerate parameters — no path generated."}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        disabled={!canExport}
                        onClick={handleDownload}
                    >
                        Download result SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
